import { HTMLAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

type GraphicAreaFooterProps = HTMLAttributes<HTMLDivElement>

export function GraphicAreaFooter(props: GraphicAreaFooterProps) {
  return <div {...props} className={twMerge(['pt-6 mr-9', props.className])} />
}
